import { render, staticRenderFns } from "./InmobiliariaCustomCols.vue?vue&type=template&id=01d54f43&scoped=true&lang=html&"
import script from "./InmobiliariaCustomCols.vue?vue&type=script&lang=js&"
export * from "./InmobiliariaCustomCols.vue?vue&type=script&lang=js&"
import style0 from "./InmobiliariaCustomCols.vue?vue&type=style&index=0&id=01d54f43&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d54f43",
  null
  
)

export default component.exports